export default __webpack_public_path__ + "images/teal-70.png";